import { useGetDossierVosOproepen } from "@/entities/medewerkers-op-station";
import { VosOproepenTable } from "@/features/medewerkers-op-station";
import { Button, Container, DataTableSkeleton } from "@/shared/components";
import { ErrorDisplay } from "@/shared/components/error";

export default function VosOproepen() {
    const { data: dossierVosOproepen, isPending, error, refetch, isRefetching } = useGetDossierVosOproepen();

    if (isPending) {
        return (
            <Container fluid>
                <div className="py-6">
                    <div className="mb-6">
                        <h1 className="text-xxl text-content-default font-bold">VOS oproepen</h1>
                        <p className="text-s text-content-subtle mt-2">Overzicht van alle VOS oproepen per dossier</p>
                    </div>
                    <DataTableSkeleton rowCount={10} columnCount={6} />
                </div>
            </Container>
        );
    }

    if (error) {
        return (
            <Container fluid>
                <ErrorDisplay error={error} variant="section" title="Fout bij het laden van VOS oproepen" />
            </Container>
        );
    }

    return (
        <Container fluid>
            <div className="py-6">
                <div className="mb-6 flex items-center justify-between">
                    <div>
                        <h1 className="text-xxl text-content-default font-bold">VOS oproepen</h1>
                        <p className="text-s text-content-subtle mt-2">Overzicht van alle VOS oproepen per dossier</p>
                    </div>
                    <Button variant="secondary" icon="refresh" onClick={() => refetch()} disabled={isRefetching}>
                        Verversen
                    </Button>
                </div>
                <VosOproepenTable dossierVosOproepen={dossierVosOproepen} />
            </div>
        </Container>
    );
}
